import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './PhoneNumberSearch.styled';
import { usePhoneNumberSearch } from './hooks';
import { OperatorSelect } from './components/OperatorSelect';
import { DigitInputs } from './components/DigitInputs';

export const PhoneNumberSearch = ({ isHidden }: { isHidden?: boolean }) => {
  const { t } = useTranslation();
  const {
    isSimCategory,
    operatorCode,
    subscriberDigits,
    canSubmit,
    canReset,
    setOperatorCode,
    setDigit,
    handleSearch,
    handleReset,
  } = usePhoneNumberSearch();
  const [isHoverSuppressed, setIsHoverSuppressed] = useState(false);

  if (!isSimCategory) {
    return null;
  }

  return (
    <S.Box $isHidden={isHidden}>
      <S.Label>{t('pages.ads.phone_number_search.hint')}</S.Label>
      <S.Controls>
        <S.InputsRow>
          <OperatorSelect
            value={operatorCode}
            onChange={setOperatorCode}
            isHoverSuppressed={isHoverSuppressed}
            setIsHoverSuppressed={setIsHoverSuppressed}
          />
          <DigitInputs
            digits={subscriberDigits}
            onDigitChange={setDigit}
            onSubmit={handleSearch}
            isHoverSuppressed={isHoverSuppressed}
            setIsHoverSuppressed={setIsHoverSuppressed}
          />
        </S.InputsRow>
        <S.Actions>
          <S.ResetButton disabled={!canReset} onClick={handleReset}>
            {t('pages.ads.phone_number_search.reset')}
          </S.ResetButton>
          <S.SearchButton disabled={!canSubmit} onClick={handleSearch}>
            {t('pages.ads.phone_number_search.search')}
          </S.SearchButton>
        </S.Actions>
      </S.Controls>
    </S.Box>
  );
};
